var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function Svg004Palette(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48.007,
    height: 48,
    viewBox: "0 0 48.007 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_004-palette",
    "data-name": "004-palette",
    transform: "translate(-2 -2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_80176",
    "data-name": "Path 80176",
    d: "M26.053,50h.019A24.044,24.044,0,0,0,49.866,29.413l.014-.13a11.372,11.372,0,0,0,.127-1.7,11.546,11.546,0,0,0-1.284-5.309l.031.065C42.171,9.824,23.646,27.14,23.648,11.6c0-6.706,0-9.6-4.8-9.6C6.8,2,2,15.666,2,26A24.027,24.027,0,0,0,26.026,50h.029Z",
    fill: "#12784a"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_3",
    "data-name": "Group 3",
    transform: "translate(6.8 11.6)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_80177",
    "data-name": "Path 80177",
    d: "M25,18a6,6,0,1,1-6-6A6,6,0,0,1,25,18Z",
    transform: "translate(8.6 2.4)",
    fill: "#02fdb1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_80178",
    "data-name": "Path 80178",
    d: "M13.2,18.6A3.6,3.6,0,1,1,9.6,15,3.6,3.6,0,0,1,13.2,18.6Z",
    transform: "translate(-1.2 6.6)",
    fill: "#3bbf83"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_80179",
    "data-name": "Path 80179",
    d: "M12.2,9.6A3.6,3.6,0,1,1,8.6,6,3.6,3.6,0,0,1,12.2,9.6Z",
    transform: "translate(-2.6 -6)",
    fill: "#3bbf83"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_80180",
    "data-name": "Path 80180",
    d: "M11.2,14.1a3.6,3.6,0,1,1-3.6-3.6A3.6,3.6,0,0,1,11.2,14.1Z",
    transform: "translate(-4 0.3)",
    fill: "#3bbf83"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg004Palette);
export default __webpack_public_path__ + "static/media/004-palette.16866d2823577c66f6ec677599541511.svg";
export { ForwardRef as ReactComponent };